import { render } from "./WinningRules.vue?vue&type=template&id=11455097"
import script from "./WinningRules.vue?vue&type=script&lang=js"
export * from "./WinningRules.vue?vue&type=script&lang=js"

import "./WinningRules.vue?vue&type=style&index=0&id=11455097&lang=css"
script.render = render

export default script